<template>
    <div>
        <b-button variant="dark" size="sm"><b-icon icon="eye" @click="open"/></b-button>
        <main-dialog v-model="openModal" :title="modalTitle" size="lg" scrollable>
            <div v-html="value" class="text-editor-content"></div>
            <template #modal-footer>
                <b-button variant="secondary" @click="openModal = false">
                    {{ $t('close') }}
                </b-button>
            </template>
        </main-dialog>
    </div>
</template>

<style lang="scss" scoped>
.text-editor-content {
    min-height: 200px;
    max-height: 600px;
    overflow-y: auto;
    padding: 15px;
    
    ::v-deep {
        img {
            max-width: 100%;
            height: auto;
        }
        
        table {
            width: 100%;
            border-collapse: collapse;
            margin: 10px 0;
            
            th, td {
                border: 1px solid #ddd;
                padding: 8px;
            }
            
            th {
                background-color: #f2f2f2;
            }
        }
        
        pre {
            background-color: #f5f5f5;
            padding: 10px;
            border-radius: 4px;
            overflow-x: auto;
        }
        
        code {
            background-color: #f5f5f5;
            padding: 2px 5px;
            border-radius: 3px;
        }
    }
}
</style>

<script>
export default {
    props: {
        field: {
            type: Object
        },
        itemField: {
            type: Object
        },
        value: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            openModal: false
        }
    },

    computed: {
        modalTitle() {
            return (this.field && this.field.label) || this.$t('content')
        }
    },

    methods: {
        open(e) {
            e.stopImmediatePropagation();
            this.openModal = true;
        }
    }
}
</script>
